import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { AdvisorDeleteAction } from "web_myplann/Advisor/Components/AdvisorDeleteAction";
import { AdvisorPickerButton } from "web_myplann/Advisor/Components/AdvisorPickerButton";
import { AdvisorSetMainAction } from "web_myplann/Advisor/Components/AdvisorSetMainAction";
import type { AgentAssignedListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";

const R = Resources.Advisor;

type Props = {
	selected?: AgentAssignedListItemResponseDTO;
	advisorsPending: number;
	showPicker: boolean;
	onOpenPicker: () => void;
	onAdvisorDeleted: () => void;
};

export const AdvisorPageHeader: FC<Props> = ({
	selected,
	advisorsPending,
	showPicker,
	onOpenPicker,
	onAdvisorDeleted,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<NavigationHeader
			title={t(R.title)}
			bgColor={theme.palette.background.appBar}
			startComponent={<AdvisorSetMainAction advisor={selected} />}
			endComponent={
				<Stack direction="row" alignItems="center" gap={theme.spacingTokens.xl}>
					{showPicker && (
						<AdvisorPickerButton
							pendingCount={advisorsPending}
							onClick={onOpenPicker}
						/>
					)}
					<AdvisorDeleteAction
						advisor={selected}
						onDeleted={onAdvisorDeleted}
					/>
				</Stack>
			}
		/>
	);
};
